import { useState, useEffect } from 'react';
import {
  ScreenScrapeForm,
  ScreenScrapeFormFooter,
} from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeForm';
import { Input } from 'src/common/components/Input';
import { useForm } from 'react-hook-form';
import { ScreenScrapeButton } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeButton';
import styled from 'styled-components';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { ScreenScrapeStepTitle } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeStepTitle';
import { ScreenScrapeLoader } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeLoader';

const StyledInput = styled(Input)`
  display: ${(props) => (props.hidden ? 'none' : 'block')};
`;

// 'mais' suffix for autocomplete problems
interface ScreenScrapeLoginFormModel {
  maisLogin: string;
  maisPassword: string;
}

export const ScreenScrapeLogin = () => {
  const [isPwdActive, setIsPwdActive] = useState(false);
  const [customTitle, setCustomTitle] = useState<string>();

  const ctx = useSSContext();

  const {
    register,
    handleSubmit,
    reset,
    formState: { isValid },
  } = useForm<ScreenScrapeLoginFormModel>();

  useEffect(() => {
    if (!ctx.isFirstMessageReceived) {
      setCustomTitle('Podaj login');
    }
  }, []);

  const onSubmit = (data: ScreenScrapeLoginFormModel) => {
    if (!data.maisPassword) {
      setIsPwdActive(true);
      setCustomTitle('Podaj hasło');
    } else {
      ctx.submitStep(null, {
        login: data.maisLogin,
        password: data.maisPassword,
      });
      reset();
      setIsPwdActive(false);
      setCustomTitle(undefined);
    }
  };

  return ctx.isLoading ? (
    <ScreenScrapeLoader />
  ) : (
    <>
      <ScreenScrapeStepTitle>
        {customTitle || ctx.lastJsonMessage?.value}
      </ScreenScrapeStepTitle>
      <ScreenScrapeForm onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <StyledInput
          hidden={isPwdActive}
          placeholder="Login"
          {...register('maisLogin', {
            required: 'To pole jest wymagane',
          })}
          autoComplete="off"
        />
        <StyledInput
          hidden={!isPwdActive}
          placeholder="Hasło"
          type="password"
          {...register('maisPassword', {
            required: isPwdActive ? 'To pole jest wymagane' : false,
          })}
          autoComplete="new-password"
        />
        <ScreenScrapeFormFooter>
          <ScreenScrapeButton type="submit" disabled={!isValid}>
            Dalej
          </ScreenScrapeButton>
        </ScreenScrapeFormFooter>
      </ScreenScrapeForm>
    </>
  );
};
